"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRumRecordEvent = exports.useRumRecordError = exports.useAwsRum = void 0;
const react_1 = require("react");
const isomorphic_1 = require("@amzn/monera-app-core/lib/isomorphic");
const aws_rum_provider_1 = require("./aws-rum-provider");
const useAwsRum = () => {
    const rumClient = (0, react_1.useContext)(aws_rum_provider_1.AwsRumContext);
    if (!rumClient) {
        isomorphic_1.LOGGER.error('Rum Client is null. Please ensure that this is invoked in the clientside and AwsRumProvider is present');
    }
    return rumClient;
};
exports.useAwsRum = useAwsRum;
const useRumRecordError = () => {
    const client = (0, exports.useAwsRum)();
    return (0, react_1.useCallback)((...params) => {
        client && client.recordError(...params);
    }, [client]);
};
exports.useRumRecordError = useRumRecordError;
const useRumRecordEvent = () => {
    const client = (0, exports.useAwsRum)();
    return (0, react_1.useCallback)((...params) => {
        client && client.recordEvent(...params);
    }, [client]);
};
exports.useRumRecordEvent = useRumRecordEvent;
